import { Box, Stack, Typography } from '@mui/material';
import useLocalization from '../../../../hooks/useLocalization';
import { FormattedBalance } from '../../../atoms/FormattedBalance';
import OddsDisplay from '../../../atoms/OddsDisplay';

const styles = {
  container: {
    gap: 0.5,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  label: {
    typography: 'body3',
    fontWeight: 600,
    color: 'neutral.300',
  },
  value: {
    typography: 'body3',
    fontWeight: 700,
    color: 'neutral.300',
  },
  strongValue: {
    typography: 'body3',
    fontWeight: 800,
  },
} as const;

type NeobetBetslipSummaryProps = {
  totalOdds: number;
  bonusAmount: number;
  totalWinningAmount: number;
};

const NeobetBetslipSummary = ({ totalOdds, bonusAmount, totalWinningAmount }: NeobetBetslipSummaryProps) => {
  const { t } = useLocalization();

  const summaryRows = [
    {
      label: t('totalOdds', 'Total Odds'),
      value: <OddsDisplay value={totalOdds} component='span' sx={styles.value} />,
    },
    {
      label: t('bonus', 'Bonus'),
      value: (
        <FormattedBalance
          balance={bonusAmount}
          variant='body3'
          sx={{
            fontWeight: 700,
            color: 'neutral.300',
          }}
        />
      ),
    },
    {
      label: t('potentialWin', 'Potential Win'),
      value: (
        <FormattedBalance
          balance={totalWinningAmount}
          variant='body3'
          sx={{
            fontWeight: 800,
          }}
        />
      ),
    },
  ];

  return (
    <Stack sx={styles.container}>
      {summaryRows.map(({ label, value }) => (
        <Box key={label} sx={styles.row}>
          <Typography sx={styles.label}>{label}</Typography>
          {value}
        </Box>
      ))}
    </Stack>
  );
};

export default NeobetBetslipSummary;
